export const getUser = (state) => {
	return state.user
}

export const getStatus = (state) => (id) => {
	return state.statuses.find(s => s.id == id)
}
